import { createSlice } from "@reduxjs/toolkit"

const videoSlice = createSlice({
    name: "video",
    initialState: {
        popularVideos: null,
        searchResults: {},
    },
    reducers: {
        setPopularVideos: (state, action) => {
            state.popularVideos = action.payload
        },
        cacheSearchResults: (state, action) => {
            const { query, results } = action.payload
            state.searchResults[query] = results
        },
    },
})

export const { setPopularVideos, cacheSearchResults } = videoSlice.actions
export default videoSlice.reducer
